import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CashClosureAccountResponse, CashClosureDayResponse, CashClosureTransferResponse, HistoryCashClosureResponse, HistoryClosureResponse } from 'src/app/models/cash-closure.model';
import { SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CashClosureService } from 'src/app/services/cash-closure.service';

@Component({
  selector: 'app-history-destination-cash-closure',
  templateUrl: './history-destination-cash-closure.component.html',
  styleUrls: ['./history-destination-cash-closure.component.scss']
})
export class HistoryDestinationCashClosureComponent {
endDate = "";
  startDate = "";
  example: HistoryCashClosureResponse[] = [];
  data: HistoryClosureResponse[] = [];
  accounts: CashClosureAccountResponse[] = [];
  countId = 1;
  showing: { [key: string]: boolean } = {};
  transferSelected = null;
  cashImage = null;
  got = false;
  buttonRollback = new ButtonLoading("btn-danger", false, "ROLLBACK", "fa-rotate-right");
  buttonConfirmDelete = new ButtonLoading("btn-danger", false, "ELIMINAR", "fa-trash");
  cashToDelete = null;
  rollbacking: { [key: number]: boolean } = {};
  payments = { 0: 'EFECTIVO', 1: 'CHEQUE', 2: 'TARJETA', 3: 'TRANSFERENCIA' };
  moreDetails: { [key: number]: boolean } = {};
  paginationAccounts: SimplePaginationModel = new SimplePaginationModel(0, 5, 0, 0, 0);
  sizes = [5, 10, 25, 50, 100];
  notifyOnDelete: boolean = true;
  loadingProducts: { [key: number]: boolean } = {};
  loadingInvoices: { [key: string]: boolean } = {};
  loadingRecovery: { [key: number]: boolean } = {};
  loadingExpenses: { [key: string]: boolean } = {};
  loadingCredit: { [key: number]: boolean } = {};
  loadingBankTransfer: { [key: string]: boolean } = {};
  loadingBankTransferDelete: { [key: number]: boolean } = {};


  constructor(
    private cashClosureService: CashClosureService,
    private toastService: ToastrService
  ) {
    var today = new Date();
    this.endDate = today.toISOString().split("T")[0];
    today.setDate(1);
    this.startDate = today.toISOString().split("T")[0];

  }

  ngOnInit(): void {
    this.refreshTables();
  }

  refreshTables() {
    this.getHistory();
  }

  getHistory() {
    if (this.startDate && this.endDate) {
      this.showing = {};
      this.cashClosureService.getHistoryCashClosureDestination(
        DateUtil.parseDateToMilliseconds(this.startDate),
        DateUtil.parseDateToMilliseconds(this.endDate)).subscribe({
          next: (response: ResponseObject) => {
            this.got = true;
            this.data = response.data;
          },
          error: (error: HttpErrorResponse) => {
            this.got = true;
            this.toastService.error("Error al obtener el historial");
          }
        })
    }
  }

  closeModalTransfer() {
    this.transferSelected = null;
  }

  gettingDetailDays(general: HistoryClosureResponse) {
    if (!this.showing["w" + general.warehouse] && !general.days) {
      this.cashClosureService.getHistoryCashClosureOfWarehouseDestination(
        DateUtil.parseDateToMilliseconds(this.startDate),
        DateUtil.parseDateToMilliseconds(this.endDate),
        general.warehouse).subscribe({
          next: (response: ResponseObject) => {
            general.days = response.data;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al obtener los intervalos");
          }
        })
    }
    this.showing["w" + general.warehouse] = !this.showing["w" + general.warehouse];
  }

  toggleProducts(day: any) {
    const key = 'p' + day.id;
    this.showing[key] = !this.showing[key];
    if (!this.showing[key]) return;
    if (day.products && Array.isArray(day.products)) return;

    this.loadingProducts[day.id] = true;

    this.cashClosureService.getProductsLiquidationIntervalDate(day.id).subscribe({
      next: (response: ResponseObject) => {
        day.products = response.data;

        this.loadingProducts[day.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loadingProducts[day.id] = false;
        this.toastService.error('Error al obtener productos del intervalo');
        this.showing[key] = false;
      }
    });
  }

  toggleInvoices(day: any, p: any) {
    const key = `i_${day.id}_${p.productId}`;
    this.showing[key] = !this.showing[key];
    if (!this.showing[key]) return;
    if (p.invoices && Array.isArray(p.invoices)) return;

    this.loadingInvoices[key] = true;

    this.cashClosureService.getDetailInvoicesLiquidationIntervalDate(day.id, p.productId).subscribe({
      next: (response: ResponseObject) => {
        p.invoices = response.data;

        this.loadingInvoices[key] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loadingInvoices[key] = false;
        this.toastService.error('Error al obtener facturas del producto');
        this.showing[key] = false;
      }
    });
  }

  private groupRecovery(rows: any[]): any[] {
    const map = new Map<string, any>();
    const result: any[] = [];

    for (const r of rows || []) {
      const external = Number(r.external ?? 0);
      const series = r.series ?? '';
      const document = r.document ?? '';

      const key = `${external}__${series}__${document}`;

      if (!map.has(key)) {
        const group = {
          external,
          series,
          document,
          clientId: r.clientId ?? null,
          clientCode: r.clientCode ?? null,
          clientName: r.clientName ?? null,
          clientNit: r.clientNit ?? null,
          total: 0,
          rows: []
        };

        map.set(key, group);
        result.push(group);
      }

      const group = map.get(key);

      group.rows.push(r);

      const n = Math.abs(Number(r.amount ?? 0));
      group.total += isNaN(n) ? 0 : n;

      group.clientId   ??= r.clientId ?? null;
      group.clientCode ??= r.clientCode ?? null;
      group.clientName ??= r.clientName ?? null;
      group.clientNit  ??= r.clientNit ?? null;
    }

    return result;
  }


  toggleRecovery(day: any) {
    const key = 'r' + day.id;
    this.showing[key] = !this.showing[key];
    if (!this.showing[key]) return;

    if (day.recoveryGroups && Array.isArray(day.recoveryGroups)) return;

    this.loadingRecovery[day.id] = true;

    this.cashClosureService.getRecoveryDetailIntervalDate(day.id).subscribe({
      next: (response: ResponseObject) => {
        const rows = (response.data || []).map((r: any) => ({
          ...r,
          amount: Math.abs(Number(r.amount ?? 0)),
          exchangeRate: r.exchangeRate ? Math.abs(Number(r.exchangeRate)) : r.exchangeRate
        }));
        day.recoveryDetail = rows;
        day.recoveryGroups = this.groupRecovery(rows);
        this.loadingRecovery[day.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loadingRecovery[day.id] = false;
        this.toastService.error('Error al obtener detalle de recuperación');
        this.showing[key] = false;
      }
    });
  }

  toggleRecoveryGroup(day: any, group: any) {
    const key = `rg_${day.id}_${group.external}_${group.series}_${group.document}`;
    this.showing[key] = !this.showing[key];
  }

  toggleCredit(day: any) {
    const key = 'c' + day.id;
    this.showing[key] = !this.showing[key];
    if (!this.showing[key]) return;

    if (day.creditInvoices && Array.isArray(day.creditInvoices)) return;

    this.loadingCredit[day.id] = true;

    this.cashClosureService.getCreditDetailIntervalDate(day.id).subscribe({
      next: (response: ResponseObject) => {
        const rows = (response.data || []).map((inv: any) => {
          const totalCost = Number(inv.totalCost ?? 0);
          const totalTaxes = Number(inv.totalTaxes ?? 0);

          const total = Math.abs(totalCost + totalTaxes);

          return {
            ...inv,
            totalCost: Math.abs(totalCost),
            totalTaxes: Math.abs(totalTaxes),
            total
          };
        });

        day.creditInvoices = rows;
        this.loadingCredit[day.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loadingCredit[day.id] = false;
        this.toastService.error('Error al obtener detalle de crédito');
        this.showing[key] = false;
      }
    });
  }



toggleExpenses(day: any) {
    const key = `e_${day.id}`;
    this.showing[key] = !this.showing[key];
    if (!this.showing[key]) return;
    if (day.expenses && Array.isArray(day.expenses)) return;

    this.loadingExpenses[key] = true;

    this.cashClosureService.getExpensesDetailIntervalDate(day.id).subscribe({
      next: (response: ResponseObject) => {
        day.expenses = response.data;
        console.log(day.expenses);
        

        this.loadingExpenses[key] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loadingExpenses[key] = false;
        this.toastService.error('Error al obtener gastos');
        this.showing[key] = false;
      }
    });
  }

  toggleBankTransfer(day: any, type: number) {
    const key = `bt_${day.id}_${type}`;
    this.showing[key] = !this.showing[key];
    if (!this.showing[key]) return;

    if (type === 1 && Array.isArray(day.bankTransfersCobaca)) return;
    if (type === 2 && Array.isArray(day.bankTransfersMaya)) return;
    if (type === 3 && Array.isArray(day.bankTransfersCooperative)) return;

    this.getBankTransfers(day, type);
  }

  getBankTransfers(day: any, type: number) {
    const key = `bt_${day.id}_${type}`;
    this.loadingBankTransfer[key] = true;

    this.cashClosureService.getBankTransferByType(day.id, type).subscribe({
      next: (response: ResponseObject) => {
        const rows = response.data || [];

        if (type === 1) day.bankTransfersCobaca = rows;
        if (type === 2) day.bankTransfersMaya = rows;
        if (type === 3) day.bankTransfersCooperative = rows;

        this.loadingBankTransfer[key] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loadingBankTransfer[key] = false;
        this.toastService.error('Error al obtener transferencias');
        this.showing[key] = false;
      }
    });
  }

  deleteBankTranfer(bankTransfer: any, type: number, day: any){
    if (bankTransfer==null) return;

    this.loadingBankTransferDelete[bankTransfer.bankAccountTransfer.id] = true;
    this.cashClosureService.deleteBankTransferByType(bankTransfer.bankAccountTransfer.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Transacción eliminada correctamente");
        this.loadingBankTransferDelete[bankTransfer.bankAccountTransfer.id] = false;
        this.getBankTransfers(day, type);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No fue posible eliminar la transacciones");
        this.loadingBankTransferDelete[bankTransfer.bankAccountTransfer.id] = false;
      }
    });

  }

}
